import { IBuilderEmailDocument, TextSubstitutionValues } from '../builderDocument';
import { ApiRoute, EmailAddress, Html, HttpMethod, Omit } from '../common';
import { WorkflowStartResult } from '../external';
import { FitwareSimpleMemberList } from '../integration';
import { LocationId } from '../location';
import { FitwareAutomatedEmailTemplateId } from '../memberEngager';
import { IPublishEmailRequest } from './email';

interface HasLocationId {
    locationId: LocationId;
}

export interface SendPreviewEmailBody {
    html: Html;
    recipient: EmailAddress;
    subject: string;
}

export interface SendFitwareEmailChannelData {
    mailingLists: number[];
    subject: string;
    scheduledTime?: Date | null;
}

export type SendFitwareEmailRequest = IPublishEmailRequest<SendFitwareEmailChannelData>;

export interface SendFitwareAutomatedEmailChannelData {
    automatedEmailCode: string;
    builderDocument: IBuilderEmailDocument;
    fitwareTemplateId?: number;
    subject: string;
    textSubstitutionValues: TextSubstitutionValues;
}

export type SendFitwareAutomatedEmailWorkflowChannelData = Omit<
    SendFitwareAutomatedEmailChannelData,
    'builderDocument'
> & {
    /*
     * Step Functions has a limit of 32kb for inputs, so we can't send the whole document up.
     * Instead, we need to save it somewhere else, and refer to that data by some ID.
     */
    fitwareAutomatedEmailTemplateId: FitwareAutomatedEmailTemplateId;
};

export type SendFitwareAutomatedEmailRequest = IPublishEmailRequest<SendFitwareAutomatedEmailChannelData>;

export const FitwarePublishApi = {
    getMemberLists: new ApiRoute<FitwareSimpleMemberList[], HasLocationId, void, void>(HttpMethod.Get, path =>
        path.literal('publish').literal('fitware').literal('location').param('locationId').literal('memberLists'),
    ),
    sendAutomatedEmail: new ApiRoute<WorkflowStartResult, HasLocationId, SendFitwareAutomatedEmailRequest, void>(
        HttpMethod.Post,
        path =>
            path
                .literal('publish')
                .literal('fitware')
                .literal('location')
                .param('locationId')
                .literal('automatedEmail'),
    ),
    sendEmail: new ApiRoute<WorkflowStartResult, HasLocationId, SendFitwareEmailRequest, void>(HttpMethod.Post, path =>
        path.literal('publish').literal('fitware').literal('location').param('locationId').literal('email'),
    ),
    sendPreviewEmail: new ApiRoute<void, HasLocationId, SendPreviewEmailBody, void>(HttpMethod.Post, path =>
        path
            .literal('publish')
            .literal('fitware')
            .literal('location')
            .param('locationId')
            .literal('email')
            .literal('preview'),
    ),
};
